<template>
  <form class="user-form uk-form-stacked" @submit.prevent="submit"
        autocomplete="false">
    <text-input ref="name"
                :label="$t('fields.name')"
                v-model="form.model.name"
                :errors="form.errors.name"
                :disabled="!isEditable" />
    <text-input ref="email"
                :label="$t('fields.email')"
                v-model="form.model.email"
                :errors="form.errors.email"
                :disabled="!isEditable"
                placeholder="user@example.com" />
    <checkbox :label="$t('fields.admin')"
              v-model="form.model.admin"
              :errors="form.errors.admin"
              :disabled="!isEditable" />
    <submit-button type="primary" :disabled="!isSubmittable" />
    <cancel-button />
  </form>
</template>

<script>
import Form from '@/mixins/LegacyForm';

export default {
  name: 'user-form',
  mixins: [
    Form({
      name: { required: true },
      email: { required: true },
      admin: { default: false },
    }),
  ],
};
</script>



// WEBPACK FOOTER //
// UserForm.vue?661374a8